import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ApiService } from 'app/services/api/api.service';
import { Http, Response, Headers } from '@angular/http';
import { map } from 'rxjs/operators';
import 'rxjs/add/operator/catch';
@Injectable()
export class UserService implements Resolve<any>
{


    constructor(private _http: Http, private apiService: ApiService)
    {
    }

    /**
     * Resolve
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
    {
        return new Promise((resolve, reject) => {
            Promise.all([


            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    addUser(data): Observable<any> {
        const httpOptions = {
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded',
            })
        };
        const _data = `name=${data.name}&lastname=${data.lastname}&email=${data.email}&password=${data.password}`;
        return this._http
            .post(this.apiService.user.create(), _data, httpOptions)
            .pipe(map((res: Response) => res.json()))
            .catch((error: Response) => Observable.throw(error.json()));
    }



}


